var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasEventReminders)?_c('div',{staticClass:"reminder-alerts-container"},[_c('div',{staticClass:"reminder-alerts-container-inner w-100"},[_c('b-alert',{staticClass:"w-100",attrs:{"variant":"info","show":_vm.hasEventReminders}},[_c('b',[_vm._v(_vm._s(_vm.trans('calendar.you_have_event_reminders')))])])],1)]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13948adf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts/EventReminders.vue
// module id = 648
// module chunks = 52